import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-gray-900 text-white overflow-hidden" style={{ fontFamily: 'Poppins,Roboto,Helvetica,Arial,sans-serif' }}>
      {/* Vibrant Arc Background Pattern for Footer */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
        {/* Large indigo arc - bottom right */}
        <div className="absolute -bottom-32 -right-24 w-[500px] h-[500px]">
          <div className="absolute inset-0 rounded-full border-[45px] border-indigo-400"></div>
          <div className="absolute inset-12 rounded-full border-[35px] border-indigo-500"></div>
          <div className="absolute inset-20 rounded-full border-[25px] border-indigo-600"></div>
        </div>
        
        {/* Purple arc - top left */}
        <div className="absolute -top-20 -left-20 w-96 h-96">
          <div className="absolute inset-0 rounded-full border-[40px] border-purple-400"></div>
          <div className="absolute inset-10 rounded-full border-[30px] border-purple-500"></div>
        </div>
        
        {/* Pink arc - middle right */}
        <div className="absolute top-1/3 -right-12 w-64 h-64">
          <div className="absolute inset-0 rounded-full border-[25px] border-pink-400"></div>
          <div className="absolute inset-8 rounded-full border-[18px] border-pink-500"></div>
        </div>
        
        {/* Blue arc - bottom left */}
        <div className="absolute -bottom-16 left-1/4 w-72 h-72">
          <div className="absolute inset-0 rounded-full border-[30px] border-blue-400"></div>
        </div>
        
        {/* Small orange accent arc */}
        <div className="absolute top-1/4 left-1/3 w-40 h-40">
          <div className="absolute inset-0 rounded-full border-[15px] border-orange-400"></div>
        </div>
      </div>

      <div className="relative container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <h3 className="font-black text-white" style={{ fontSize: '32px' }}>
                ArcRefinery
              </h3>
              <p className="text-gray-400 -mt-1" style={{ fontSize: '16px' }}>Storytelling meets AI</p>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Transform your social media video ads with AI-powered insights, storytelling guidance and creative briefs. 
              Get comprehensive scoring, actionable recommendations and platform-specific optimisation tips to maximise your creative performance.
            </p>
          </div>

          {/* Features */}
          <div>
            <h4 className="font-semibold mb-4">Features</h4>
            <ul className="space-y-2 text-gray-400">
              <li><span className="hover:text-white transition-colors cursor-default">Multi-Platform Analysis</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">AI-Powered Insights</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">Detailed Scoring</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">Actionable Recommendations</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">Platform Best Practices</span></li>
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="font-semibold mb-4">Supported Platforms</h4>
            <ul className="space-y-2 text-gray-400">
              <li><span className="hover:text-white transition-colors cursor-default">Meta (Facebook/Instagram)</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">TikTok</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">Instagram</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">YouTube</span></li>
              <li><span className="hover:text-white transition-colors cursor-default">Twitter/X</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center text-gray-400 text-sm mb-4 md:mb-0">
              <span>Made with</span>
              <Heart className="w-4 h-4 mx-1 text-red-500" />
              <span>for content creators and marketers</span>
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
            <p className="text-gray-400 text-sm">
              © 2025 ArcRefinery. All rights reserved.
            </p>
          </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <span className="hover:text-white transition-colors cursor-default">Privacy Policy</span>
              <span className="hover:text-white transition-colors cursor-default">Terms of Service</span>
              <span className="hover:text-white transition-colors cursor-default">Contact</span>
            </div>
          </div>
          
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;
